// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormCreateNewPassword } from '~/utils/interface/auth';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      newPassword: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' }))
        .min(8, t('common_validate_password_limit', { ns: 'common/base' })),
      passwordConfirm: yup
        .string()
        .required(t('common_validate_field_required', { ns: 'common/base' }))
        .test('passwords-match', t('common_validate_password_match', { ns: 'common/base' }), function (value) {
          const { newPassword } = this.parent;
          return !value || value === newPassword;
        }),
    })
    .required();
};

export const defaultValuesForm: IFormCreateNewPassword = {
  newPassword: EMPTY_STRING,
  passwordConfirm: EMPTY_STRING,
};
